import React from 'react';
import Spinner from '@atlaskit/spinner';
import { ErrorState } from './error-state';
import { CenteredWrapper, CurrentContentWrapper } from './styled';
export const Content = ({
  isFetchLoading,
  hasError,
  isSubmissionLoading,
  content,
  errorContent,
  testId
}) => {
  if (isFetchLoading) {
    return /*#__PURE__*/React.createElement(CenteredWrapper, null, /*#__PURE__*/React.createElement(Spinner, {
      size: "xlarge",
      testId: `${testId}-fetch-spinner`
    }));
  }
  if (hasError && !isSubmissionLoading) {
    return /*#__PURE__*/React.createElement(ErrorState, {
      errorContent: errorContent,
      testId: testId
    });
  }
  return /*#__PURE__*/React.createElement(CurrentContentWrapper, {
    "data-testid": `${testId}-blanket`,
    submitting: !!isSubmissionLoading
  }, content);
};